export default "__VITE_ASSET__BviGYXBD__"